import { styled } from '@mui/material/styles';
import { CircularProgress, IconButton, IconButtonProps } from '@mui/material';
import _ from 'lodash';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

interface ExpandMoreStyledProps extends IconButtonProps {
  expand: boolean;
}

const ExpandMoreStyled = styled((props: ExpandMoreStyledProps) => {
  const { ...other } = _.omit(props, 'expand');
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(90deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest
  })
}));

interface ExpandMoreProps {
  isLoading?: boolean;
  expanded: boolean;
  onExpand: (didExpand: boolean) => void;
  'aria-label'?: string;
}

const ExpandMore: React.VFC<ExpandMoreProps> = (props) => {
  const { isLoading, expanded, onExpand, 'aria-label': ariaLabel = 'show more' } = props;

  if (isLoading) {
    return <CircularProgress size={20} />;
  }

  return (
    <ExpandMoreStyled expand={expanded} onClick={() => onExpand(!expanded)} aria-expanded={expanded} aria-label={ariaLabel}>
      <ChevronRightIcon />
    </ExpandMoreStyled>
  );
};

export default ExpandMore;
